import { API_ENDPOINTS } from "@/api/services/helpdesk/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const myTicketApi = baseApi.injectEndpoints({
  //   baseQuery: fetchBaseQuery({
  //     baseUrl: process.env.REACT_APP_DEV_API_URL,
  //     prepareHeaders: (headers) => {
  //       headers.set("Content-Type", "application/json");
  //       const loginDetails = localStorage.getItem("loginDetails");
  //       const authToken = loginDetails ? JSON.parse(loginDetails).token : null;
  //       if (authToken) {
  //         headers.set("Authorization", `Bearer ${authToken}`);
  //       }

  //       return headers;
  //     },
  //   }),


  endpoints: (builder) => ({
    fetchMyTicketPending: builder.query({
      query: () => ({
        url: API_ENDPOINTS.MYTICKET.FETCH_MYTICKET_PENDING,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "myTicket", id: "LIST" }],
    }),
    fetchMyTicketCompleted: builder.query({
      query: () => ({
        url: API_ENDPOINTS.MYTICKET.FETCH_MYTICKET_COMPLETED,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "myTicket", id: "LIST" }],
    }),

    statusChange: builder.mutation({
      query: ({ id, formData }) => ({
        url: API_ENDPOINTS.MYTICKET.STATUS_CHANGE(id),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "myTicket", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchMyTicketPendingQuery,
  useFetchMyTicketCompletedQuery,
  useStatusChangeMutation,
} = myTicketApi;
